export default "__VITE_ASSET__CPHW$Qab__"